
import { Watch, Component, Vue, Ref, ProvideReactive } from "vue-property-decorator";
import PulseTaking from "./pulseTaking.vue";
import Lung from "./lung.vue";
import Tongue from "./tongue.vue";
import Phy from "./phy.vue";
import Height from "./height.vue";
import FourDiagnostic from "./fourDiagnostic.vue";
import CopyPrescriptionDialog from "./copyPrescriptionDialog.vue";
import Nurse from "./nurse.vue";
import AiWeightTongue from "./aiWeightTongue.vue";
import AiWeightPhy from "./aiWeightPhy.vue";
import { prescriptionModuleNameList } from "@/api/prescriptionDb";

@Component({ name: 'prescription-db-component-prescriptionLib',
  inject: [],
  components: {
    PulseTaking,
    Lung,
    Tongue,
    Phy,
    Height,
    FourDiagnostic,
    CopyPrescriptionDialog,
    Nurse,
    AiWeightTongue,
    AiWeightPhy,
  },
})
export default class PrescriptionLib extends Vue {
  @Ref("pulseTakingRef") readonly pulseTakingRef!: PulseTaking;
  @Ref("lungRef") readonly lungRef!: Lung;
  @Ref("tongueRef") readonly tongueRef!: Tongue;
  @Ref("phyRef") readonly phyRef!: Phy;
  @Ref("heightRef") readonly heightRef!: Height;
  @Ref("fourDiagnosticRef") readonly fourDiagnosticRef!: FourDiagnostic;
  @Ref("nurseRef") readonly nurseRef!: Nurse;
  @Ref("aiWeightTongueRef") readonly aiWeightTongueRef!: AiWeightTongue;
  @Ref("aiWeightPhyRef") readonly aiWeightPhyRef!: AiWeightPhy;

  @ProvideReactive() pageCurrentTab = "1";

  @ProvideReactive()
  merchantId = this.$route.query.merchantId;
  brandName = this.$route.query.brandName;

  keyword = "";
  currentTab = "1";

  paginationInfo = {
    currentPage: 1,
    pageSize: 20,
    itemTotal: 0,
  };

  copyVisible = false;

  // 模块自定义名称，提供给表格表头和处方弹窗使用
  @ProvideReactive() moduleTitles: any = {};
  @ProvideReactive() moduleTitlesLoaded = false;

  mounted() {
    this.getModuleTitles();
  }

  // 获取模块自定义名称
  getModuleTitles() {
    if (!this.merchantId) {
      this.moduleTitlesLoaded = true;
      return;
    }
    prescriptionModuleNameList({ merchantId: this.merchantId }).then((res: any) => {
      const fieldMap: any = {
        "项目调养": "projectTitle",
        "居家保养": "homeTitle",
        "膳食运动": "dietTitle",
        "调养规划": "planTitle",
        "备注说明": "remarkTitle",
      };
      const titles: any = {};
      (res.data || []).forEach((item: any) => {
        const field = fieldMap[item.moduleCode];
        if (field && item.customName) titles[field] = item.customName;
      });
      this.moduleTitles = titles;
      this.moduleTitlesLoaded = true;
    }).catch(() => {
      this.moduleTitlesLoaded = true;
    });
  }

  // 配置页保存后，切回处方库时刷新标题
  refreshModuleTitles() {
    this.getModuleTitles();
  }

  syncTotal(total) {
    this.paginationInfo.itemTotal = total;
  }

  handleSizeChange(val: number) {
    this.paginationInfo.pageSize = val;
    this.searchPrescriptionDb();
  }

  handleCurrentChange(val: number) {
    this.paginationInfo.currentPage = val;
    this.searchPrescriptionDb();
  }

  resetPage() {
    this.paginationInfo.currentPage = 1;
  }

  // 触发子组件的查询
  searchPrescriptionDb(isFirst = false) {
    if (isFirst) {
      this.paginationInfo.currentPage = 1;
    }
    const queryParam = { symptomName: this.keyword, pageNum: this.paginationInfo.currentPage, pageSize: this.paginationInfo.pageSize };

    if (this.currentTab == "1") {
      this.pulseTakingRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
    if (this.currentTab == "2") {
      this.tongueRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
    if (this.currentTab == "3") {
      this.phyRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
    if (this.currentTab == "4") {
      this.lungRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
    if (this.currentTab == "5") {
      this.lungRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
    if (this.currentTab == "6") {
      this.fourDiagnosticRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
    if (this.currentTab == "7") {
      this.nurseRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
    if (this.currentTab == "8") {
      this.aiWeightTongueRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
    if (this.currentTab == "9") {
      this.aiWeightPhyRef?.prescriptionSymptom(this.currentTab, queryParam)
    }
  }

  copyPrescription() {
    this.copyVisible = true;
  }

  @Watch("currentTab", { immediate: true })
  setProductType(value: string) {
    this.keyword = "";
    this.pageCurrentTab = value;
  }
}
